module.exports = __webpack_public_path__ + "static/coffee-4042935_1920-31873c12c40469884f6dab6577330e65.png";